import { IApplicationState } from '../../../../types/types';
import { IProduct } from '../types';

export const getProducts = (
    state: IApplicationState
): IProduct[] => {
    return state.model.products;
};
